if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();
        this.select = this.querySelector('select');

        this.init();
        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }
        this.productId = this.dataset.productId;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const method = entry.intersectionRatio !== 1 ? 'add' : 'remove';
              this.container.classList[method]('sticky-atc-bar--show');
            });
          },
          { threshold: 1, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.productFormActions);
        this.observeTarget = this.productFormActions;
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.sticky-atc-bar__form');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };


        const moneyFormat = FoxTheme.settings.moneyFormat;

        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        // Get private discount and hide_compare_at_price from data attributes
        const privateDiscount = parseFloat(this.dataset.privateDiscount) || 0;
        const hideCompareAtPrice = this.dataset.hideCompareAtPrice === 'true';
        
        let { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // Apply private discount to prices (cumulative with existing discounts)
        if (privateDiscount > 0) {
          const discountMultiplier = 1 - privateDiscount;
          
          // If product has compare_at_price AND hide_compare_at_price is false, keep original compare_at_price
          if (compare_at_price && compare_at_price > price && !hideCompareAtPrice) {
            price = Math.round(price * discountMultiplier);
            // compare_at_price stays as is (original price)
          } else {
            // Otherwise, original price becomes compare_at_price
            compare_at_price = price;
            price = Math.round(price * discountMultiplier);
          }
        }

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        const newPrice = (price) => {
          // Get the vat exclusion label (HT in french)
          let excl_vat = window.i18n.product.ht_label;

          // If swiss market, convert the price to CHF
          if (window.swissMarketInfos) {
            let newPrice = (price * window.swissMarketInfos.chf_rate) / 100;
            let newPriceFormatted = window.swissMarketInfos.currency + " " + newPrice.toFixed(2);

            return newPriceFormatted + " " + excl_vat;
          } else {
            // If not swiss market, format the price to the money format (like by default in the theme)
            return FoxTheme.Currency.formatMoney(price, moneyFormat) + " " + excl_vat;
          }
        }

        if (salePrice) salePrice.innerHTML = newPrice(price);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = newPrice(compare_at_price))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = newPrice(price)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          let unitPriceValue = this.currentVariant.unit_price;
          
          // Apply discount to unit price
          if (privateDiscount > 0) {
            unitPriceValue = Math.round(unitPriceValue * (1 - privateDiscount));
          }

          const newUnitPrice = (unitPriceValue) => {
            // Get the vat exclusion label (HT in french)
            let excl_vat = window.i18n.product.ht_label;
            // If swiss market, convert the unit price to CHF
            if (window.swissMarketInfos) {
              let newPrice = (unitPriceValue * window.swissMarketInfos.chf_rate) / 100;
              let newPriceFormatted = window.swissMarketInfos.currency + " " + newPrice.toFixed(2);
  
              return newPriceFormatted + " " + excl_vat;
            } else {
              // If not swiss market, format the unit price to the money format (like by default in the theme)
              return FoxTheme.Currency.formatMoney(unitPriceValue, moneyFormat) + " " + excl_vat;
            }
          }
          
          const unitPriceContent = `<span>${newUnitPrice(
            unitPriceValue,
          )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }
    }
  );
}
